import { Button, type ButtonProps } from '@chakra-ui/react';
import { type FC } from 'react';

import { trackContentInteraction } from '$/logger';
import {
  type PiwikContentInteraction,
  type PiwikContentName,
  type PiwikContentPiece,
  type PiwikContentTarget,
} from '$/utils/piwikUtils';

export interface TrackedButtonProps extends ButtonProps {
  contentInteraction?: PiwikContentInteraction;
  contentName?: PiwikContentName;
  contentPiece?: PiwikContentPiece;
  contentTarget?: PiwikContentTarget;
}

export const TrackedButton: FC<TrackedButtonProps> = ({
  contentInteraction,
  contentName,
  contentPiece,
  contentTarget,
  onClick,
  ...props
}) => {
  return (
    <Button
      onClick={(e) => {
        if (contentName && contentPiece && contentTarget) {
          trackContentInteraction(
            contentInteraction ?? 'ClickButton',
            contentName,
            contentPiece,
            contentTarget,
          );
        }

        if (onClick) {
          onClick(e);
        }
      }}
      {...props}
    />
  );
};
